import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const CreateClassOfferingMutation = graphql.persisted(
  "CreateClassOffering",
  graphql(`
    mutation CreateClassOffering($input: CreateClassOfferingInput!) {
      createClassOffering(input: $input) {
        classOffering {
          id
          section
          displayName
          term { id name startsOn endsOn }
          course { id name }
        }
        userErrors { message path }
      }
    }
  `),
);

export { CreateClassOfferingMutation };

export function useCreateClassOffering() {
  return useMutation(CreateClassOfferingMutation);
}
